import type { RoomState } from "../types";
import { PhaseTimer } from "./PhaseTimer";

interface Props {
  room: RoomState;
}

export function ReferenceReveal({ room }: Props) {
  return (
    <div className="reveal">
      <div className="reveal-head">
        <h2>Behold your subject</h2>
        <p className="muted">
          Round {room.round} of {room.totalRounds} — study this little guy. You'll be drawing them next.
        </p>
        <PhaseTimer endsAt={room.phaseEndsAt} label="Drawing starts in" />
      </div>
      {room.reference && (
        <div className="reveal-photo">
          <img src={room.reference.url} alt="Today's cat" />
        </div>
      )}
    </div>
  );
}
